var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3720_3533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.62036 5.95933C8.86986 5.95933 7.70848 5.10592 6.48536 5.136C4.87036 5.15737 3.38994 6.07254 2.5579 7.52208C0.881943 10.4315 2.12565 14.7286 3.76044 17.0933C4.5624 18.2444 5.50844 19.5396 6.76244 19.4992C7.96578 19.4478 8.41703 18.7178 9.87765 18.7178C11.3272 18.7178 11.7381 19.4992 13.0127 19.4683C14.3086 19.4478 15.1312 18.2967 15.9228 17.1345C16.838 15.7982 17.218 14.5022 17.2386 14.431C17.2077 14.4207 14.7195 13.4643 14.6894 10.5858C14.6688 8.17917 16.6527 7.02808 16.7454 6.97662C15.6141 5.32204 13.8772 5.13679 13.2699 5.09562C11.6866 4.97213 10.3606 5.95854 9.62036 5.95854V5.95933ZM12.2946 3.53208C12.962 2.73092 13.4029 1.61071 13.2802 0.5C12.3247 0.541167 11.1728 1.13729 10.4841 1.93925C9.86657 2.64858 9.33298 3.79017 9.47628 4.8795C10.5355 4.96183 11.6257 4.33483 12.2938 3.53288",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3720_3533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.568e92386705017c41337ec99080c7d8.svg";
export { ForwardRef as ReactComponent };